<template>
  <div class="navbar">
    <div class="navbar-title">HEAR THE VOICE OF MYANMAR</div>
  </div>
</template>

<script>
export default {
    name: "Navbar"
};
</script>

<style>
.navbar {
    background: black;
    position: fixed;
    width: 100vw;
    z-index:55;
    top: 0;
}

.navbar-title{
    color: white;
    font-family: 'Oswald';
    text-align: center;
    padding: 2vh 0;
}
</style>